

export const NoCourseProvided = () =>
{
    return (
        <div className='flex flex-col items-center justify-center min-h-screen bg-slate-50 p-6'>
            <div className='flex flex-col items-center bg-white rounded-2xl p-8 shadow-card max-w-sm w-full'>

                {/* Icon */}
                <div className='w-14 h-14 rounded-full bg-amber-50 flex items-center justify-center mb-4'>
                    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24"
                         fill="none" stroke="#d97706" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <circle cx="12" cy="12" r="10"></circle>
                        <line x1="12" y1="8" x2="12" y2="12"></line>
                        <line x1="12" y1="16" x2="12.01" y2="16"></line>
                    </svg>
                </div>

                <h1 className='text-lg font-bold text-slate-900 mb-2'>No Course Found</h1>
                <p className='text-sm text-slate-500 text-center leading-relaxed'>
                    Please use the link provided by your course to access the menu.
                </p>
            </div>
        </div>
    )
}